import { SideNavigationLink } from "../../../components/SideNavigation";

export const REVIEWS_TABLE_LIMIT = 25;
export const CompanyReviewsNavigationLinks: SideNavigationLink[] = [
	{
		label: "Review Cycles",
		href: "/company/reviews/cycles/",
		key: "cycles",
	},
	{
		label: "All Reviews",
		href: "/company/reviews/all/",
		key: "all",
	},
	{
		label: "All Forms",
		href: "/company/reviews/form-report/",
		key: "form-report",
	},
	{
		label: "Assignments",
		href: "/company/reviews/overview/",
		key: "overview",
	},
	{
		label: "Performance Graphs",
		href: "/company/reviews/graphs/",
		key: "graphs",
		fullPageLoad: true,
	},
];
